export function formatCounter(count: number): string {
  return count > 99 ? '99+' : count.toString();
}
